!function($) {

  // Add custom JavasScript here
  // --------------------------



  // Document ready
  $(function() {


  });

}(jQuery);
(function () {
  if (window.tcpFilterRemoveFix) return;
  window.tcpFilterRemoveFix = true;

  document.addEventListener("click", function (event) {
    if (
      event.button !== 0 ||
      event.metaKey || event.ctrlKey ||
      event.shiftKey || event.altKey
    ) return;

    const link = event.target instanceof Element
      ? event.target.closest("facet-remove a[href]")
      : null;

    if (!link) return;

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(url.href);
  }, true);
})();